import { Model } from '@vuex-orm/core';
import Residence from '@/models/Residence';
import Date from '@/models/Date';

export default class File extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'files';

  // List of all fields (schema) of the file model.
  static fields() {
    return {
      id: this.uid(),
      filename: this.attr(null),
      url: this.attr(null),
      title: this.string(''),
      alt: this.attr(null),
      caption: this.attr(null),
      description: this.attr(null),
      mime_type: this.attr(null),
      type: this.attr(null),
      subtype: this.attr(null),

      // Relationship IDs
      residence_id: this.attr(null),

      // Relationships
      date: this.morphOne(Date, 'dateable_id', 'dateable_type'),
      residence: this.belongsTo(Residence, 'residence_id'),
    };
  }
}
